import * as React from 'react';
import Pagination from '@mui/material/Pagination';

import { Box, Grid, IconButton, Typography } from '@mui/material';
import { useState } from 'react';
import { useEffect } from 'react';
import { AcUnit } from '@mui/icons-material';
import { useLocation, useParams } from 'react-router-dom';
import ApprovalChart from '../Chart/ApprovalChart'
import StatusChart from '../Chart/StatusChart'
import AttachmentGrid from '../DataGrid/AttachmentGrid'
import CommonChart from '../Chart/CommonChart';
import ApprovalInfoGrid from '../DataGrid/ApprovalInfoGrid';

const PaginationSystem = ({ palette, approvalChart, statusChart, count }) => {
    const [page, setPage] = useState(1);
    const handleChange = (event, value) => {
        setPage(value);
    };

    // const showComponent = () => {
    //     switch (page) {
    //         case 1:
    //             return <ApprovalChart />;
    //         case 2:
    //             return <StatusChart />;
    //         case 3:
    //             return <AttachmentGrid />;
    //         default:
    //             return <AttachmentGrid />;
    //     }
    // }

    let showComponent;
    const url = useLocation().pathname
    const { dataId } = useParams();


    function getPageComponent(page, additionalProps = {}) {
        switch (page) {
            case 1:
                return <ApprovalChart />;
            case 2:
                return <StatusChart />;
            case 3:
                return <ApprovalInfoGrid {...additionalProps} />;
            default:
                return <AttachmentGrid />;
        }
    }

    switch (url) {
        case '/requests':
            showComponent = getPageComponent(page, { lineDisabled: false });
            break;

        case '/requests/${dataId}':
            showComponent = getPageComponent(page, { lineDisabled: true });
            break;

        case '/rfqs':
        case '/rfqs/${dataId}':
        case '/bid-comparison':
        case '/bids-card-company':
        case '/bids/${dataId}':
        case '/bid-comparison/${dataId}':
            showComponent = getPageComponent(page);
            break;

        case `/orders`:
        case `/bids`:
        case `/orders/${dataId}`:
            switch (page) {
                case 1:
                    showComponent = (
                        <Box flexGrow={1}>
                            <Typography variant="h6" mb={1}>Approval Information</Typography>
                            <CommonChart data={approvalChart} height={100} />
                        </Box>
                    );
                    break;
                case 2:
                    showComponent = (
                        <Box flexGrow={1}>
                            <Typography variant="h6" mb={1}>Status Information</Typography>
                            <CommonChart data={statusChart} height={100} palette={palette} />
                        </Box>
                    );
                    break;
                default:
                    showComponent = <Box flexGrow={1}>
                        <Typography variant="h6" mb={1}>Status Information</Typography>
                        <CommonChart data={statusChart} height={100} palette={palette} />
                    </Box>;
            }
            break;

    

        default:
            showComponent = (
                <>
                    empty
                </>
            )
            break;
    }

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleWindowResize = () => {
            setScreenWidth(window.innerWidth);
        };
        window.addEventListener("resize", handleWindowResize);

        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);

    let size;

    switch (true) {
        case screenWidth > 2210:  //xll 4k
            size = 600;
            break;
        case screenWidth > 1440:  //xl 1440 - 2560 4K
            size = 420;
            break;
        case screenWidth > 1024:  //lg 1024 - 1440 Laptop L
            size = 330;
            break;
        case screenWidth > 768:   //md 768 - 1024 Laptop
            size = 395;
            break;
        case screenWidth > 425:   //sm 425 - 768 Tablet
            size = 720;
            break;
        case screenWidth > 375:   //xs 375 - 425 Mobile L
            size = 400;
            break;
        case screenWidth > 320:   //xs 320 - 375 Mobile M
            size = 320;
            break;
        case screenWidth > 0:     //xs 0 - 320 Mobile S
            size = 300;
            break;
        default:
            size = 300;
    }

    return (
        <>
            <Grid container display="flex" justifyContent="center"  >
                <Box sx={{ width: size, height: 150 }}>
                    {showComponent}
                </Box>
            </Grid>

            <Grid container display="flex" alignItems="center" mt={3} justifyContent="space-between">
                <Grid item xs={9}>
                    <Pagination size="small" count={count} page={page} onChange={handleChange} color="primary" />
                </Grid>
                <Grid item xs={3} display="flex" justifyContent="flex-end">
                    {/* <IconButton color="primary" component="label">
                        <AcUnit />
                    </IconButton> */}
                </Grid>
            </Grid>
        </ >
    );
}

export default PaginationSystem